

import { Injectable, EventEmitter, Output } from '@angular/core';
import { ConstantesService } from './constantes.service';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Injectable()
export class UtilService {

  /**
   * Metodo que convierte calcula la cantidad de horas respecto a los segundos
   * @param hora
   * @param minutos
   * @param segundos
   */
  public convertirHoraMinutos(hora: number, minutos: number): number {
    //horas a segundos
    return hora * 3600 + minutos * 60;
  }

  /**
   * convierte una fecha Date a string en formato   'yyyy-mm-dd hh:mm:ss'
   * @param fechaActu
   */
  public convertirDatetoString(fechaActu: Date): string {
    return fechaActu.getFullYear()
      + '-' + (fechaActu.getMonth() + 1)
      + '-' + fechaActu.getDate();
  }

  /**
    * convierte una fecha Date a string en formato   'yyyy-mm-dd hh:mm:ss'
    * @param fechaActu 
    */
  public convertirDate(fechaActu: Date): string {

    var month = (fechaActu.getMonth() + 1).toString();
    if (month.length < 2) {
      month = '0' + month;
    }

    var day = fechaActu.getDate().toString();
    if (day.length < 2) {

      day = '0' + day;
    }

    return fechaActu.getFullYear().toString()
      + '-' + month
      + '-' + day
      + ' ' + (fechaActu.getHours().toString())
      + ':' + (fechaActu.getMinutes().toString())
      + ':' + (fechaActu.getSeconds().toString());
  }

  /**
   * validar campos obligatorios
   * @param  campo campo a validar
   * @return True si es valido, false de lo contrario
   */
  public validarCamposObligatorios(campo) {
    return campo != undefined && campo != 'UNDEFINED' && campo != 'undefined' && campo != null
      && (typeof campo != 'string' || campo.trim() != '');
  }

  // fromero
  // 05/06/2019
  // metodo para validar correo electrónico
  validarCorreo(correo) {
    const regex = /^(([^<>()[\]\.,;:\s@\']+(\.[^<>()[\]\.,;:\s@\']+)*)|(\'.+\'))@(([^<>()[\]\.,;:\s@\']+\.)+[^<>()[\]\.,;:\s@\']{2,})$/i;
    let correoInvalido = true;
    if (correo !== '' && correo) {
      const reps = regex.test(correo);
      correoInvalido = !reps;
    }
    return correoInvalido;
  }


  /**
 * Obtiene la hora actual en formato hh:mm:ss
 * @author fromero
 */
  public initHoraActual(): string {
    var horaActual = null;
    const horaTemp = new Date();
    var minutes = (horaTemp.getMinutes().toString());
    if (minutes.length < 2) {
      minutes = '0' + minutes;
    }
    var seconds = horaTemp.getSeconds().toString();
    if (seconds.length < 2) {
      seconds = '0' + seconds;
    }
    horaActual = horaTemp.getHours().toString() + ':' + minutes + ':' + seconds;
    return horaActual;
  }

  /**
   * devuelve fecha en string formato 'dia de mes de año'
   */
  public obtnerFechaLetras(fecha: Date): string {
    const año = fecha.getFullYear().toString();
    const nummes = fecha.getMonth();
    const mes = ConstantesService.MESES[nummes];
    const dia = fecha.getDate().toString();
    return dia + ' de ' + mes + ' de ' + año;

  }

  /**
   * Método de control de Excepciones
   * @param  error mensaje saliente respecto al error ocurrido
   * @return void
   */
  cathException(error: any, alertService, spinner?) {
    if (typeof error === 'string') {
      alertService.generateAlertError(error, 'Error');
    } else if (error.error && error.error.message && error.error.message.length < 250 &&
      !error.error.message.includes('EJB')) {
      alertService.generateAlertError(error.error.message, 'Error');
    } else {
      try {
        let JsonError = JSON.parse(error.error);
        alertService.generateAlertError(JsonError.message, 'Error');
      } catch (e) {
        alertService.generateAlertError('Ocurrio un error,por favor intente más tarde', 'Error');
      }
    }
    if (spinner) {
      spinner.hide();

    }
  }


  /**
   * Metodo que retorna un string  de la fecha concatenado con un 0 para el mes o dia
   * que contengan un solo numero
   */

  public convertirFechaConcatenada(event) {
    let d = event.fecha.day;
    let m = event.fecha.month;
    const y = event.fecha.year;
    if (event.fecha.month.toString().length < 2) {
      m = '0' + m;
    }
    if (event.fecha.day.toString().length < 2) {
      d = '0' + d;
    }
    return d + '-' + m + '-' + y;
  }

  /**
   * @author klagos@
   * Metodo que separa un string tomando en cuenta el primer espacio de la cadena
   * Usado para guardar nombres y apellidos en diferentes columnas.
   */

  public separarString(cadena: string) {

    const cadenaSeparada = cadena.split(' ');
    const texto1 = cadenaSeparada[0];
    let texto2 = null;
    if (cadenaSeparada.length > 1) {
      cadenaSeparada.shift();
      texto2 = ' ' + cadenaSeparada.join(' ');
    }
    return [texto1, texto2];

  }

  toDate(struct: NgbDate): Date {
    return new Date(struct.year, struct.month - 1, struct.day);
  }

  toStruct(date: Date | string): NgbDate {
    if (typeof date === 'string') {
      try {
        date = moment(date).toDate();
        // date = new Date(Date.parse(date));
      } catch (e) {
        return undefined;
      }
    }
    return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }

  fromStringToDate(date: Date | string, adicionar: boolean): Date {
    if (typeof date === 'string') {
      try {
        date = moment(date).toDate();
      } catch (e) {
        return undefined;
      }
    }
    return adicionar ? moment(date).add(1, 'day').toDate() : date;
  }

  setearFinFecha(date: Date) {
    let finFecha = date;
    finFecha.setHours(0, 0, 0, 0);
    return finFecha;
  }


}
